package fyi.moko.hotpl.data.location

import fyi.moko.hotpl.domain.model.GeoPoint
import kotlinx.browser.window
import kotlin.coroutines.resume
import kotlinx.coroutines.suspendCancellableCoroutine

class JsCurrentLocationProvider : CurrentLocationProvider {
    override fun isPermissionGranted(): Boolean {
        return true
    }

    override suspend fun lastKnownLocation(): GeoPoint? = suspendCancellableCoroutine { continuation ->
        val geolocation = window.navigator.asDynamic().geolocation
        if (geolocation != null) {
            geolocation.getCurrentPosition(
                { position ->
                    val coords = position.coords
                    continuation.resume(GeoPoint(coords.latitude as Double, coords.longitude as Double))
                },
                {
                    continuation.resume(null)
                }
            )
        } else {
            continuation.resume(null)
        }
    }
}
